import React, { Suspense } from 'react';

import { SearchDialog } from '@atlassian/search-dialog/search-dialog';

import { ResolvedAndErrorContent } from './resolved-and-error-content';
import { SearchSkeletons } from './search-skeletons';

type SearchDropdownProps = {
	cloudId: string;
	helpCenterAri: string;
	inputWidth: number;
	queryWord: string;
};

export const SearchDropdown = ({
	inputWidth,
	...props
}: SearchDropdownProps): React.JSX.Element => {
	return (
		<SearchDialog
			/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
			style={{
				boxShadow: 'none',
				width: inputWidth,
			}}
			/* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */
		>
			<Suspense fallback={<SearchSkeletons />}>
				<ResolvedAndErrorContent {...props} />
			</Suspense>
		</SearchDialog>
	);
};
